module.exports = __webpack_public_path__ + "static/pakmaya-basari-hikayesi-91ce7f0fc5cd79d8589e71e019f23683.jpg";